import React, { useEffect, useState } from 'react'
import { UlUser, LiUser } from '../../common/formParts/FieldPartsStyled'
import ModalBase from "../../modals/base"
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import Times from '../../common/formParts/icons/Times.svg'

const ConfirmModal = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(props.isVisible || false)
  const [modalData, setModalData] = useState([])
  const [selectedDestinationsValues, setSelectedDestinationsValues] = useState([])
  const [noDataToDisplay, setNoDataToDisplay] = useState(false)

  const getSelectedData = () => {
    const selectedDestinations = document.querySelectorAll("div[name^=selector\\[")
    const selectedDestinationsArray = Array.from(selectedDestinations)
    const values = selectedDestinationsArray.map((dest) => {
      let destTypeName = ''
      if (dest.getAttribute('data-destination-type') === 'app') {
        destTypeName = 'アプリ'
      } else if (dest.getAttribute('data-destination-type') === 'article') {
        destTypeName = '物件'
      } else if (dest.getAttribute('data-destination-type') === 'delivery_group') {
        destTypeName = '配信グループ'
      } else if (dest.getAttribute('data-destination-type') === 'member_dwelling_unit') {
        destTypeName = '会員住戸'
      }
      return {
        name: dest.getAttribute('data-destination-name'),
        type: destTypeName,
      }
    })
    setSelectedDestinationsValues(values)

    // get all : 会員住戸 selected
    // on the current page parse all checkbox input fields that are checked and their values
    const inputs = document.querySelectorAll("input:checked[name^=news\\[member_dwelling_unit\\]")
    let inputsArray = Array.from(inputs)

    // get the hidden inputs (case of 選択済み会員住戸 tab)
    const inputsHidden = document.querySelectorAll('input[type="hidden"][name^=news\\[member_dwelling_unit\\]')
    const inputsArrayHidden = Array.from(inputsHidden)

    inputsArray = inputsArray.concat(inputsArrayHidden)
    // keep unique values
    inputsArray = inputsArray.filter((input, index, self) =>
      index === self.findIndex((t) => (
        t.value === input.value
      ))
    )

    let inputValues = inputsArray.map((input) => {
      return {
        user_article_id: input.value,
        username: input.getAttribute('data-username'),
        room: input.getAttribute('data-room'),
        destination_name: input.getAttribute('data-destination-name'),
      }
    })
    // group by destination_name
    inputValues = inputValues.reduce((acc, obj) => {
      const key = obj.destination_name
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push({ user_article_id: obj.user_article_id, username: obj.username, room: obj.room })
      return acc
    }, {})

    // Show or not the message "配信先が選択されていないようです。"
    let showNoData = false;
    // Check if there is at least one destination name that is not empty
    const hasNotEmptyDestination = values.some((dest) => (dest.name !== '' && dest.name !== null));
    // Check if there are no selected employees
    const noSelectedEmployees = Object.keys(inputValues).length === 0;
    if (hasNotEmptyDestination) {
      // Check if there is at least one destination name that is not empty and there are no selected employees
      if (noSelectedEmployees) {
        // Check if there is any other destination name that is not empty and its type is not '会員住戸'
        const hasOtherNonEmptyDestination = values.some((dest) => (dest.name !== '' && dest.name !== null && dest.type !== '会員住戸'));
        showNoData = !hasOtherNonEmptyDestination;
      }
    } else {
      showNoData = true;
    }
    setNoDataToDisplay(showNoData)
    setModalData(inputValues)
  }

  const handleOnClose = () => {
    setIsModalVisible(false)
  }

  const setModalVisible = (value) => {
    setIsModalVisible(value)
  }

  useEffect(() => {
    if (isModalVisible) { getSelectedData() }
  }, [isModalVisible])

  return (
    <ModalBase isVisible={isModalVisible} setModalVisible={setModalVisible} fullWidth={true} >
      <Inner>
        <div className="modal-header">
          <h3>選択した全ての配信先</h3>
          <div className="modal-close" onClick={handleOnClose}>
            <SVG src={Times} className="icon" title="閉じる" />
          </div>
        </div>
        <div className="modal-body">
          {noDataToDisplay ? <div className="empty-destination">配信先が選択されていないようです。</div>
            :
            <div>
              {/* for App, Article, Group Selection */}
              {selectedDestinationsValues.map((destination, index) => {
                return (
                  destination.name &&
                  destination.type != "会員住戸" && (
                    <div className="modal-block" key={`modal-block-` + index}>
                      <h4>{destination.type}</h4>
                      <span>{destination.name}</span>
                    </div>
                  )
                )
              })}

              {/* for members selection :  */}
              {Object.keys(modalData).map((article, index) => {
                return (
                  <div className="modal-block" key={`modal-block-` + index}>
                    <h4>会員住戸</h4>
                    <span>{article}</span>
                    {/*
                      <ul className="user-list-header">
                        <LiUser key={`modal-header-user-` + index} className='selectedUsers'>
                          <div>会員名</div>
                          <div>部屋番号</div>
                        </LiUser>
                      </ul>
                      */}
                    <UlUser className="user-list-body">
                      {modalData[article].map((user, index) => {
                        return (
                          <LiUser key={`modal-user-` + index} className='selectedUsers'>
                            <div>{user.username}</div>
                            <div>{user.room}</div>
                          </LiUser>
                        )
                      })}
                    </UlUser>
                  </div>
                )
              })}
            </div>
          }
        </div>
      </Inner>
    </ModalBase>
  )
}

export default ConfirmModal

const Inner = styled.div`
  position: absolute;
  width: 60%;
  background: white;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  border-radius: 4px;
  .modal-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1rem;
    padding: 1.25rem 0;
    border-bottom: 1px solid #ccc;
    h3 {
      font-size: 16px;
      font-weight: 400;
    }
    .modal-close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      right: 16px;
      width: 32px;
      height: 32px;
      transform: translateY(-50%);
      border-radius: 50%;
      transition: background-color .2s;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, .1);
      }
    }
  }
  .modal-body {
    min-height: 100px;
    max-height: 60vh;
    padding-bottom: 2rem;
    overflow-y: auto;
    overflow-x: hidden;
    .modal-block {
      position: relative;
      padding: 1.5rem 1rem;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 1rem;
        right: 1rem;
        border-bottom: 1px solid #ccc;
      }
    }
    h4 {
      display: inline-block;
      width: 6rem;
      padding: 0.25rem 0.5rem;
      margin-right: 0.5rem;
      font-size: 13px;
      text-align: center;
      background-color: #e5e5e5;
      border-radius: 4px;
    }
    ul {
      max-height: none;
      overflow-y: visible;
      overflow-x: hidden;
      &.user-list-body {
        padding: 0;
        margin-top: 0.5rem;
        li {
          padding-left: 0;
          border-bottom: 1px dashed #ccc;
          &:hover {
            background: inherit;
            cursor: default;
          }
          &:last-child {
            border: 0;
          }
          > div {
            &:first-child {
              padding-left: 0;
            }
          }
        }
      }
    }
    .empty-destination {
      padding: 3rem 0 2rem;
      color: #556;
      text-align: center;
    }
  }
`;
